import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";
import {AlertService} from "../services/alert.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private router:Router,
    private alertService:AlertService,
    private translate: TranslateService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    return next.handle(request).pipe(

      catchError( (err: HttpErrorResponse) :Observable<HttpEvent<unknown>> =>  {
        if (err) {
          switch (err.status) {
            case 400:

              break;
            case 401:

              break;
            case 409:
              this.alertService.warning(this.translate.instant('ALERTS.' + err?.error?.reason));
              break;

            default:

              break;
          }
          throw err;
        }
        return null;
      })
    )
  }







  }
